import styled from 'styled-components/macro';

export const Title = styled.h1`
  font-size: 32px;
  font-weight: bold;
  color: ${p => p.theme.text};
  margin: 1rem 0;
`;
